module.exports = __webpack_public_path__ + "img/maturity-not-start.6976edaa.svg";